// extracted by mini-css-extract-plugin
export default {"section":"accessRequestPanel_section__CWyod","btnContainer":"accessRequestPanel_btnContainer__SdEMW","btn":"accessRequestPanel_btn__88wKm"};